export default __webpack_public_path__ + "static/media/logoPayID32.da9e52d3.svg";